/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPeach = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.959 5.962c-2.332 1.555-3.229 4.684-2.887 7.566.25 2.108 1.083 3.9 2.516 5.321 1.42 1.41 3.372 2.4 5.78 3.027l.616.154.24-.059c2.463-.606 4.47-1.593 5.95-3.012 1.494-1.43 2.395-3.247 2.72-5.4.528-3.49-.966-7.28-4.413-8.315l-.03-.01-.032-.006c-.613-.142-1.585-.222-2.472.093-.273.097-.55.236-.804.43.205-.822.604-1.4 1.04-1.808.661-.618 1.458-.89 1.941-.95l-.248-1.985c-.85.106-2.053.534-3.059 1.474a5.49 5.49 0 0 0-1.02 1.289 5.281 5.281 0 0 0-.787-1.003C9.69 1.448 7.826.952 6.145 1.443l-.526.154-.153.525a4.91 4.91 0 0 0 .493 3.84zm4.288-.853a5.652 5.652 0 0 0-2.432.048 2.983 2.983 0 0 1-.532-1.894c.795-.05 1.645.25 2.313.919.282.282.5.597.651.927zm3.872 2.617a.728.728 0 0 1 .125-.274.777.777 0 0 1 .373-.246c.39-.14.925-.123 1.32-.037 2.136.663 3.417 3.203 2.98 6.092-.265 1.753-.978 3.155-2.126 4.254-1.118 1.071-2.699 1.904-4.807 2.454l-.117-.03c-2.175-.566-3.773-1.42-4.87-2.51-1.086-1.077-1.737-2.439-1.939-4.136-.352-2.967.872-5.492 3.007-6.133a3.726 3.726 0 0 1 2.793.26 4.35 4.35 0 0 1 1.436 1.198 5.1 5.1 0 0 1 .941 1.978l1.946-.465a7.175 7.175 0 0 0-1.062-2.405z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPeach as Peach };
